<template>
    <div class="tab-content">
        <h2 class="tab-content--title">
            Welcome Back
        </h2>

        <login-form />
    </div>
</template>

<script>
import LoginForm from '@/components/Login/LoginForm';
import { redirectIfInIframeMixin } from '@/mixins/redirectIfInIframeMixin';

export default {
    name: 'Login',

    components: { LoginForm },

    mixins: [redirectIfInIframeMixin],
};
</script>

<style></style>